import Vue from 'vue'
import Router from 'vue-router'
// import Index from '@/components/Index'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Rmzb',
      component: () => import('@/components/rmzb')
    },
    // {
    //   path: '/',
    //   name: 'Index',
    //   component: Index
    // },
    {
      path: '/zbgy',
      name: 'Zbgy',
      component: () => import('@/components/zbgy')
    },
    {
      path: '/zjcns',
      name: 'Zjcns',
      component: () => import('@/components/zjcns')
    },
    {
      path: '/fwxy',
      name: 'Fwxy',
      component: () => import('@/components/fwxy')
    },
    {
      path: '/jfcl',
      name: 'Jfcl',
      component: () => import('@/components/jfcl')
    },
    {
      path: '/wcnrbhzr',
      name: 'Wcnrbhzd',
      component: () => import('@/components/wcnrbhzr')
    },
    {
      path: '/nrzsglzd',
      name: 'Nrzsglzd',
      component: () => import('@/components/nrzsglzd')
    },
    {
      path: '/jguan',
      name: 'Jguan',
      component: () => import('@/components/jguan')
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/components/login')
    },
    {
      path: '/video',
      name: 'Video',
      component: () => import('@/components/video')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js